import React, { useEffect } from "react";
import Helmet from "react-helmet";

const HeadLinks = (props) => {
  let noPrev = false;
  let noNext = false;
  let prevLinkHref = "";
  let nextLinkHref = "";
  let canonicalLinkHref = "";
  prevLinkHref =
    window.location.protocol +
    "//" +
    window.location.hostname +
    props.base +
    "page/" +
    parseInt(props.page - 1) +
    "/";
  nextLinkHref =
    window.location.protocol +
    "//" +
    window.location.hostname +
    props.base +
    "page/" +
    parseInt(props.page + 1) +
    "/";
  canonicalLinkHref =
    window.location.protocol +
    "//" +
    window.location.hostname +
    props.base +
    "page/" +
    props.page +
    "/";
  if (props.page === 1) {
    noPrev = true;
    nextLinkHref =
      window.location.protocol +
      "//" +
      window.location.hostname +
      props.base +
      "page/2/";
    canonicalLinkHref =
      window.location.protocol +
      "//" +
      window.location.hostname +
      window.location.pathname;
  }
  if (props.page === 2) {
    prevLinkHref =
      window.location.protocol + "//" + window.location.hostname + props.base;
    nextLinkHref =
      window.location.protocol +
      "//" +
      window.location.hostname +
      props.base +
      "page/3/";
  }
  if (props.pageCount && props.page === props.pageCount.length) {
    prevLinkHref =
      window.location.protocol +
      "//" +
      window.location.hostname +
      props.base +
      "/";
    canonicalLinkHref =
      window.location.protocol +
      "//" +
      window.location.hostname +
      props.base +
      "page/" +
      props.page +
      "/";
    noNext = true;
  }
  const description = document.querySelector('meta[name="description"]');
  const canonical = document.querySelector('link[rel="canonical"]');
  useEffect(() => {
    if (props.page !== 1 && canonical) {
      canonical.remove();
    }
    if (props.page !== 1 && description) {
      description.remove();
    }
  }, []);
  return (
    <>
      <Helmet>
        {!noPrev && <link rel="prev" href={prevLinkHref} />}
        {!noNext && <link rel="next" href={nextLinkHref} />}
        {props.page !== 1 && (
          <title>
            Page {props.page.toString()} review results for "
            {window.lrmSettings["brand_name"]}"
          </title>
        )}
        {props.page !== 1 && (
          <meta
            name="description"
            content={`Page ${props.page.toString()} review results for "${
              window.lrmSettings["brand_name"]
            }" - Click to read "${
              window.lrmSettings["brand_name"]
            }'s" page ${props.page.toString()} review results. Read detailed reviews from our customers here!`}
          />
        )}
        <link rel="canonical" href={canonicalLinkHref} />
      </Helmet>
    </>
  );
};

export default HeadLinks;
